import React, { useState } from 'react'
import './Navbar.css'

export default function Navbar ({data}) {
    const [showLinks, setShowLinks] = useState(false);
    return (
        <>
            <header className="header">
                <img 
                    src="https://autoboys.co.za/wp-content/uploads/2022/10/cropped-ab_logo-01-1.png"
                    className="header--image"
                    alt = "logo"
                />
                <h2 className="header--title">{data?.title}</h2>
                <h4 className="header--address">Warehouse Address: <br/> {data?.address}</h4>
                <h4 className="header--contact">Email: {data?.email} <br/> Tel: {data?.tel}</h4>
            </header>
            <div>
                {/* <h5  className="warehouse-picker">
                    Switch Warehouse:
                    <a href='https://abgs.link/JHBParts'>JHB</a>
                    <a href='https://abgs.link/DBNParts'>DBN</a>
                    <a href='https://abgs.link/CPTParts'>CPT</a>
                    <a href='https://abgs.link/PEParts'>PE</a>
                    <a href='https://abgs.link/GRGParts'>GEORGE</a>
                    <a href='https://abgs.link/ELParts'>EL</a>
                </h5> */}
                <button id="refresh-button" onClick={() => window.location.reload(true)}>Refresh 🔄️</button>
            </div>
            <div>
                <button id="links-button" onClick={() => setShowLinks(!showLinks)}>Useful Links {showLinks ? "⬆️" : "⬇️"}</button>
                {showLinks ? (<>
                    <h5><a href='https://abgs.link/Valeo' target="_blank" rel="noreferrer">Valeo Wipers</a></h5>
                    <h5><a href='https://abgs.link/ValeoCat' target="_blank" rel="noreferrer">Valeo Catalog</a></h5>
                </>) : null }
            </div>
        </>
    )
}